<template>
  <div class="ticketlist">
    <div class="headerImage">
      <img src="~@/assets/image/common/common_header.png" alt="" />
    </div>
    <state v-if="$store.state.ticketResources.length" :resourcesObj="$store.state.ticketResources[0]"></state>
    <selector select="selector-about"></selector>
    <router-view></router-view>
    <policyNotice v-if="$store.getters.checkPolicy"></policyNotice>
    <indexNotice v-if="$store.getters.checkReminder"></indexNotice>
  </div>
</template>

<script>
import state from "@/components/entry/buyTicketHome/state/index.vue";
import policyNotice from "@/components/entry/buyTicketHome/policyNotice/index.vue";
import selector from "@/components/entry/buyTicketHome/selector/index.vue";
import personalCenter from "@/components/entry/buyTicketHome/personalCenter/index.vue";

export default {
  name: "sls",
  components: {
    state,
    selector,
    policyNotice,
    personalCenter
  },
};
</script>

<style scoped lang='less'>
.ticketlist{
  background: #3B6D9C;
}
</style>
